import { imageList } from "@/core/utils/imageList";
import { AccountSetupFormData, Plan } from "../../model/types";

interface CompletionStepProps {
  formData: Partial<AccountSetupFormData>;
  plans: Plan[];
  plansLoading: boolean;
  isCompleting: boolean;
  completionError: string | null;
  onComplete: () => void;
}

export const CompletionStep = ({
  formData,
  plans,
  plansLoading,
  isCompleting,
  completionError,
  onComplete,
}: CompletionStepProps) => {
  const showPlansSelection =
    formData.organizationAction === "create" && formData.organizationDetails;

  // Get monthly price for professional plan
  const professionalPlan = plans.find(
    (plan) => plan.product_name === "Professional Plan",
  );
  const monthlyPrice = professionalPlan
    ? parseInt(professionalPlan.base_price) / 12
    : 15;

  if (showPlansSelection) {
    return (
      <div className="step-content step-9">
        <div className="step-header" />

        {plansLoading && (
          <div className="loading-container">
            <i className="pi pi-spinner pi-spin"></i>
            <p>Loading plans...</p>
          </div>
        )}

        <div className="plans-container">
          <div className="plans-title">Start your free trial</div>
          <div className="plan-item">
            <div className="plan-header">
              <div className="plan-icon">
                <img src={imageList.zap} alt="Plan icon" />
              </div>
              Professional plan
            </div>
            <div className="plan-body">
              <div className="plan-body-title">Free for 14 days</div>
              <div className="plan-body-subtitle">
                then {monthlyPrice}€ per month, if billed annually*
              </div>
              <div className="plan-body-feature-title">
                Access the following pro features:
              </div>
              <div className="plan-body-features">
                <div className="plan-body-featureItem">
                  <img src={imageList.checkIcon} alt="Check" />
                  Personalized calls just for you
                </div>
                <div className="plan-body-featureItem">
                  <img src={imageList.checkIcon} alt="Check" />
                  Calls' interested partners
                </div>
                <div className="plan-body-featureItem">
                  <img src={imageList.checkIcon} alt="Check" />
                  Funding goals
                </div>
              </div>
            </div>
          </div>

          <div className="plan-footer">
            *After the trial period, you will be automatically renewed for an
            annual subscription of the Professional plan.
          </div>
        </div>

        {!plansLoading && plans.length === 0 && (
          <div className="error-message">
            Failed to load plans. Please try again.
          </div>
        )}

        {completionError && (
          <div
            className="error-message"
            style={{ marginBottom: "1rem", color: "#e74c3c" }}
          >
            {completionError}
          </div>
        )}

        <button
          type="button"
          className="submit-button"
          onClick={onComplete}
          disabled={isCompleting}
        >
          {isCompleting ? "Creating Organization..." : "Let's start"}
        </button>
      </div>
    );
  }

  // Default completion step (for join/skip organization)
  return (
    <div className="step-content step-9">
      <div className="completion-icon">
        <i className="pi pi-check-circle"></i>
      </div>
      <h2 className="completion-title">Account Setup Complete!</h2>
      <p className="completion-message">
        Your account has been set up successfully. You can now start exploring
        European funding opportunities.
      </p>
      {completionError && (
        <div
          className="error-message"
          style={{ marginBottom: "1rem", color: "#e74c3c" }}
        >
          {completionError}
        </div>
      )}
      <button
        type="button"
        className="submit-button"
        onClick={onComplete}
        disabled={isCompleting}
      >
        {isCompleting ? "Completing Setup..." : "Complete Setup"}
      </button>
    </div>
  );
};
